export default __webpack_public_path__ + "phone.svg";